import React from 'react'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { TradingControlLimitDetail, UserPreference } from 'api'
import { tradingControlLimitDetailsSelector } from 'selectors/tradingControlSelectors'
import styled from '@emotion/styled'
import { Locale, Translation } from 'locale'
import { createUserPreferenceSelector } from 'selectors/userPreferenceSelectors'
import { getNotionalFormatOptions } from 'view/shared/datagrid'
import { CORE_PRIMARY, CORE_PRIMARY_1, CORE_PRIMARY_6 } from 'view/styles/constants'
import { Decimal } from 'utils'

interface TradingControlViewProps {
  tradingControlLimitList: TradingControlLimitDetail[]
  userPreference: UserPreference
}

const mapStateToProps = createStructuredSelector({
  tradingControlLimitList: tradingControlLimitDetailsSelector,
  userPreference: createUserPreferenceSelector()
})

const Container = styled.div`
  width: 100%;
  background: ${CORE_PRIMARY};
  height: 100%;
`

const Table = styled.table`
  width: 500px;
  margin: 32px 0 0 32px;
  text-align: left;
  border-spacing: 0;

  th,
  td {
    height: 30px;
    padding: 0 10px;
    font-size: 12px;
    border: 1px solid ${CORE_PRIMARY_1};
  }

  th {
    background: ${CORE_PRIMARY_1};
    color: ${CORE_PRIMARY_6};
  }
`

export const TradingControlViewComponent: React.FunctionComponent<TradingControlViewProps> = ({
  tradingControlLimitList,
  userPreference
}) => {
  const formatOptions = getNotionalFormatOptions(userPreference.amountFormat)

  return (
    <Container>
      <Table>
        <thead>
          <tr>
            <th>{Locale.translate(Translation.TC_ORGANISATION)}</th>
            <th>{Locale.translate(Translation.TC_LIMIT, { amountFormat: userPreference.amountFormat })}</th>
            <th>{Locale.translate(Translation.TC_UTILISATION, { amountFormat: userPreference.amountFormat })}</th>
            <th>{Locale.translate(Translation.TC_AVAILABLE, { amountFormat: userPreference.amountFormat })}</th>
          </tr>
        </thead>
        <tbody>
          {tradingControlLimitList.map(({ tradingControlLimit: { id, limit, utilisation, displayAvailable }, organisation }) => (
            <tr key={id}>
              <td>{organisation?.legalName}</td>
              <td>{Locale.formatNumber(limit, formatOptions)}</td>
              <td>{Locale.formatNumber(Decimal.abs(utilisation), formatOptions)}</td>
              <td>{Locale.formatNumber(displayAvailable, formatOptions)}</td>
            </tr>
          ))}
        </tbody>
      </Table>
    </Container>
  )
}

export const TradingControlView = connect(mapStateToProps)(TradingControlViewComponent)
